// extracted by mini-css-extract-plugin
export default {"default":"Tooltip_default__is9Io","dark":"Tooltip_dark__XfH2t"};